import { render, staticRenderFns } from "./RestaurantProfile.vue?vue&type=template&id=453e1a0e&scoped=true"
import script from "./RestaurantProfile.vue?vue&type=script&lang=js"
export * from "./RestaurantProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e1a0e",
  null
  
)

export default component.exports